(() => {
  const roots = document.querySelectorAll('[data-studio-story]');

  roots.forEach((root) => {
    const progress = root.querySelector('[data-reading-progress]');
    const shareButton = root.querySelector('[data-share-story]');
    const shareStatus = root.querySelector('[data-share-status]');

    const updateProgress = () => {
      if (!progress) return;
      const top = root.getBoundingClientRect().top + window.scrollY;
      const total = Math.max(root.offsetHeight - window.innerHeight, 1);
      const value = Math.min(Math.max((window.scrollY - top) / total, 0), 1);
      progress.style.transform = `scaleX(${value})`;
    };

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);

    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        const shareData = { title: document.title, url: window.location.href };
        try {
          if (navigator.share) {
            await navigator.share(shareData);
            if (shareStatus) shareStatus.textContent = 'Share panel opened.';
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(window.location.href);
            if (shareStatus) shareStatus.textContent = 'Link copied.';
          }
        } catch (error) {
          if (error?.name !== 'AbortError' && shareStatus) shareStatus.textContent = 'Copy the address from your browser.';
        }
      });
    }

    root.querySelectorAll('details').forEach((detail) => {
      const summary = detail.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', String(detail.open));
      detail.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(detail.open)));
    });
  });
})();
